import {
  Component,
  ElementRef,
  Input,
  ViewChild,
  OnInit,
  AfterViewInit
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalController, NavParams, NavController } from '@ionic/angular';
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';
import { IconType, IconPath } from 'src/app/shared/models/floor-plan-icon.model';
import { NewPageSelectComponent } from 'src/app/shared/components/new-page-select/new-page-select.component';
import { AppService} from '../../../service';

import * as dd from 'dingtalk-jsapi'; // 引入钉钉jsapi
import { FabricCanvasCnComponent } from '../fabric-canvas-cn/fabric-canvas-cn.component';
import { DataService, } from '../../../service/data.service'
import { fabric } from 'fabric';
import { cloneDeep } from 'lodash';

declare var Hammer: any;
const AREA_STYLE = {
  fill: 'rgba(24, 144, 255, 0.2)',   // 浅蓝填充
  stroke: '#1890ff',               // 蓝色边框
  strokeWidth: 3,
  rx: 4,
  ry: 4
};

enum FileType {
  PDF = 'pdf',
  JPG = 'jpg',
  JPEG = 'jpeg',
  PNG = 'png',
  SVG = 'svg'
}

// Hammer
GlobalWorkerOptions.workerSrc = 'assets/pdfjs/pdf.worker.min.js';

@Component({
  selector: 'gmp-floor-plan-dialog',
  templateUrl: './gmp-floor-plan-dialog.component.html',
  styleUrls: ['./gmp-floor-plan-dialog.component.scss']
})
export class GmpFloorPlanDialogComponent implements OnInit, AfterViewInit {
  @ViewChild('scrollBox') scrollBox!: ElementRef;
  mapUrl: string;
  // fileType: string;
  pointData: any[] = [];
  markerType: IconType;
  mode: 'view' | 'point' = 'view';
  showStats = false;
  statsData: any;
  multiplePoints = false;
  module: 'floor-plan' | 'heat-map' = 'floor-plan';

  // @ViewChild('canvas1') canvasRef: ElementRef;
  @ViewChild('mychart') mychartRef: ElementRef;
  @ViewChild('fabricCanvasCn') fabricCanvasCn: FabricCanvasCnComponent;
  
  readonly markerSize = 32;
  readonly offset = this.markerSize / 2;

  imageOffset = { x: 0, y: 0 };
  imageScale = 1;
  canvasWidth = 0;
  canvasHeight = 0;
  pointAxis;
  isPdf = false;
  statsItems = [
    { label: 'Check Count (excluding drafts/closed)', value: 0 },
    { label: 'BBS Observation Count', value: 0 },
    { label: 'Contractor Projects', value: 0 },
    { label: 'Contractor Work Items', value: 0 },
    { label: 'Contractor Workers', value: 0 },
    { label: 'Incident Count', value: 0 },
    { label: 'Risk Points', value: 0 },
    { label: 'Risk Assessments', value: 0 },
    { label: 'GMP Audits', value: 0 }
  ];

  // 缩放的变量
  scale = 1;
  isDragging = false;
  lastScale = 1;
  lastPosX = 0;
  lastPosY = 0;
  posX = 0;
  posY = 0;
  originalWidth = 0;
  originalHeight = 0;
  // fabricCanvas: fabric.Canvas;
  isPanning = false
  store = {
    scale: 1, //图片缩放
    pageX: '',
    pageY: '',
    // moveable:false,
    pageX2: '',
    pageY2: '',
    originScale: 0
  }

  top = 0 //y轴坐标
  left = 0 //x轴坐标
  ot = 0
  ol = 0
  screenWidth: any;
  minScale = 0.5;
  maxScale = 5;
  zoomStep = 0.1;

  iconLeft;
  iconTop;
  iconPosition;

  selectedDrawingPlan;
  width: number = 800;
  height: number = 600;
  floorPlanUrl: string;
  fileType: FileType;
  shapes: any[] = [];
  nodes = [];
  markData;
  mapId;
  orgId;
  checkRequired = false;
  formDetail;
  // pointData;
  // mode;
  // pointAxis: any;
  // markerType;
  showPoint = false;
  drawingDetail: any;
  selectedAreaData: any;
  selectedAreaText;
  @ViewChild(FabricCanvasCnComponent) fabricCanvas: FabricCanvasCnComponent;
  @ViewChild('canvasBox') canvasRef: ElementRef;
  changeMap = false;
  isLoading = false;
  drawingManagementList = [];
  gmpFloorPlan;

  constructor(
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    public navParams: NavParams,
    private translateService: TranslateService,
    private apiService: DataService,
    public appService: AppService,
  ) {
    let params = this.navParams.data;
    this.iconPosition = params.iconPosition ? params.iconPosition : null
    this.floorPlanUrl = params.mapUrl ? params.mapUrl : '';
    this.fileType = params.fileType ? params.fileType.replace('.', '') : '';
    this.pointData = params.pointData ? params.pointData : [];
    this.shapes = params.shapes ? params.shapes : [];
    this.markerType = params.markerType ? params.markerType : IconType.LocationPoint;
    this.mode = params.mode ? params.mode : 'view';
    this.showStats = params.showStats ? params.showStats : false;
    this.statsData = params.statsData ? params.statsData : {};
    this.multiplePoints = params.multiplePoints ? params.multiplePoints : false;

    this.selectedDrawingPlan = params.selectedDrawingPlan ? params.selectedDrawingPlan : null;
    this.drawingManagementList = params.drawingManagementList ? params.drawingManagementList : [];
  }

  ngOnInit() {
    // 设置标题
    document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.view_floor_plan');
    if (dd.env.platform !== 'notInDingTalk') {
      dd.biz.navigation.setTitle({
        title: this.translateService.instant('shared_components.common.view_floor_plan') // 钉钉设置导航栏标题
      });
    }


  }

  async ngAfterViewInit() {
    const img = new Image();
    img.src = this.mapUrl;
    img.onload = () => {
      const imgWidth = img.naturalWidth;
      const imgHeight = img.naturalHeight;
      const canvasEl = this.canvasRef.nativeElement;
      if (!canvasEl) return;

      // this.fabricCanvas = new fabric.Canvas(canvasEl, {
      //   selection: true,
      //   preserveObjectStacking: true
      // });
      // this.fabricCanvas.setWidth(800);
      // this.fabricCanvas.setHeight(540);


      if (this.pointData && this.pointData.length > 0) {
        this.drawRandomShapes();
      }
      const overlayCanvas = this.canvasRef ? this.canvasRef.nativeElement : null;

      const container = document.getElementById('mychart');
      if (!container) return;

      // this.fabricCanvas.on('mouse:down', (opt) => {
      //   const evt = opt.e as MouseEvent;
      //   this.isPanning = true;
      //   this.lastPosX = evt.clientX;
      //   this.lastPosY = evt.clientY;
      //   this.fabricCanvas.selection = false;

      //   console.log(this.lastPosX);
      //   console.log(this.lastPosY);
      // });
    }



  }
  drawRandomShapes() {
    if (!this.fabricCanvas) return;

    this.pointData.forEach(v => {

      let shape: fabric.Object;
      switch (v.markMapList[0].type) {
        case 'circle':
          shape = new fabric.Circle({
            ...v.markMapList[0]
          });
          break;
        case 'rect':
          shape = new fabric.Rect({
            ...v.markMapList[0]
          });
          break;

        case 'triangle':
          shape = new fabric.Triangle({
            ...v.markMapList[0]
          });
          break;

        case 'polygon':
          const minX = Math.min(...v.markMapList[0].points.map(p => p.x));
          const minY = Math.min(...v.markMapList[0].points.map(p => p.y));

          const points = v.markMapList[0].points.map(p => ({
            x: p.x - minX,
            y: p.y - minY
          }));

          shape = new fabric.Polygon(points, {
            left: minX,
            top: minY,
            fill: v.markMapList[0].fill,
            stroke: v.markMapList[0].stroke,
            strokeWidth: v.markMapList[0].strokeWidth,
            scaleX: v.markMapList[0].scaleX || 1,
            scaleY: v.markMapList[0].scaleY || 1,
            angle: v.markMapList[0].angle || 0
          });
          break;
      }

      // this.fabricCanvas.add(shape);
    })

    // this.fabricCanvas.renderAll();
  }

  getRandomType(): 'circle' | 'rect' | 'triangle' {
    const types = ['circle', 'rect', 'triangle'];
    return types[Math.floor(Math.random() * types.length)] as any;
  }

  random(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  randomColor(): string {
    const colors = ['#ff4d4f', '#40a9ff', '#73d13d', '#faad14', '#9254de'];
    return colors[Math.floor(Math.random() * colors.length)];
  }

  async cancel() {
    await this.modalCtrl.dismiss();
    history.back();
  }

  async confirm() {
    if (!this.markData) {
      this.appService.toastTip(this.translateService.instant('shared_components.gmp_floor_plan_dialog.please_mark_one_point_on_floor_plan'), true);
      return;
    }

    let selectedItem = null;
    if (this.pointData && this.pointData.length) {
      this.pointData.forEach((i) => {
        if (i.markMapList && i.markMapList.length && this.selectedAreaData) {
          const a = i.markMapList.find((m) => m.objectId == this.selectedAreaData.objectId);
          if (a) {
            selectedItem = i;
          }
        }
      })
    }

    await this.modalCtrl.dismiss({
      mark: this.markData, 
      area: selectedItem, 
      isChangeMap: this.changeMap,
      drawingDetail: this.changeMap ? this.drawingDetail : this.selectedDrawingPlan
    });
    history.back();
  }

  // 重置视图
  resetView() {
    this.scale = 1;
    this.posX = 0;
    this.posY = 0;
  }
  setPoint(e) {
    // this.fabricCanvas.on('mouse:down', (opt) => {
    //   const e = opt.e as MouseEvent;

    //   const target = opt.target;        // 👈 当前点击的对象（最重要）

    //   const subTargets = opt.subTargets; // 👈 group 内子元素（可选）
    //   console.log(target, 'target');
    // });
    console.log(this.fabricCanvas);
    // const pointer = this.fabricCanvas.getPointer(e);
    // console.log(pointer, 'pointer');
    const wrapper = document.getElementsByClassName('pdf-wrapper')[0] as HTMLElement;
    if (!wrapper) return;
    this.iconLeft = e.offsetX - 20
    this.iconTop = e.offsetY - 20

    const rect = wrapper.getBoundingClientRect();

    // 👇 点击点在 wrapper 内的坐标
    const clickX = e.offsetX - 20;
    const clickY = e.offsetY - 20;

    const startScale = this.store.scale;
    const targetScale = 1.5;

    if (startScale === targetScale) return;

    const startLeft = this.iconLeft;
    const startTop = this.iconTop;

    const duration = 300; // 动画时长 ms
    const startTime = performance.now();

    const animate = (now: number) => {
      const progress = Math.min((now - startTime) / duration, 1);

      // easeOutCubic（自然一点）
      const ease = 1 - Math.pow(1 - progress, 3);

      const currentScale =
        startScale + (targetScale - startScale) * ease;

      // 🔑 关键：以点击点为缩放中心
      const scaleRatio = currentScale / startScale;

      this.left = -(this.iconLeft / 10)
      // startLeft - (clickX - startLeft) * (scaleRatio - 1) - 100;

      this.top = -(this.iconTop / 10)
      // startTop - (clickY - startTop) * (scaleRatio - 1) - 100;

      this.store.scale = currentScale;

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);

  }
  //开始触摸
  // startMap(e: any) {

  //   if (this.mapUrl) {
  //     const product_fuide = document.getElementsByClassName('pdf-wrapper')[0] as HTMLElement

  //     this.ol = e.touches[0].clientX - product_fuide.offsetLeft;
  //     this.ot = e.touches[0].clientY - product_fuide.offsetTop;
  //     var touches = e.touches;
  //     var events = touches[0];
  //     var events2 = touches[1];
  //     if (!events) {
  //       return;
  //     }

  //     // 第一个触摸点的坐标
  //     this.store.pageX = events.pageX;
  //     this.store.pageY = events.pageY;
  //     // this.store.moveable = true;
  //     if (events2) {
  //       this.store.pageX2 = events2.pageX;
  //       this.store.pageY2 = events2.pageY;
  //     }
  //     this.store.originScale = this.store.scale || 1;
  //     // console.log(index)
  //   }
  // }
  // // 移动中
  // moveMap(e: any) {
  //   if (this.mapUrl) {
  //     let left = e.touches[0].clientX;
  //     let top = e.touches[0].clientY;
  //     this.top = top - this.ot - 100;
  //     this.left = left - this.ol - 20;
  //     // e.preventDefault();
  //     let store = this.store
  //     var touches = e.touches;
  //     var events = touches[0];
  //     var events2 = touches[1];
  //     if (events2) {
  //       // 双指移动
  //       if (!store.pageX2) {
  //         store.pageX2 = events2.pageX;
  //       }
  //       if (!store.pageY2) {
  //         store.pageY2 = events2.pageY;
  //       }

  //       // 获取坐标之间的举例
  //       var getDistance = function (start: any, stop: any) {
  //         return Math.hypot(stop.x - start.x, stop.y - start.y);
  //       };

  //       var zoom = getDistance({
  //         x: events.pageX,
  //         y: events.pageY
  //       }, {
  //         x: events2.pageX,
  //         y: events2.pageY
  //       }) /
  //         getDistance({
  //           x: store.pageX,
  //           y: store.pageY
  //         }, {
  //           x: store.pageX2,
  //           y: store.pageY2
  //         });

  //       var newScale = store.originScale * zoom;
  //       // 最大缩放比例限制
  //       if (newScale > 3) {
  //         newScale = 3;
  //       } else if (newScale < 1) {
  //         newScale = 1;
  //       }
  //       // 记住使用的缩放值
  //       this.store.scale = newScale;
  //     }
  //   }
  // }
  //结束
  endMap() {

  }

  onWheel(e: WheelEvent) {
    e.preventDefault(); // ⛔ 阻止页面滚动
    const wrapper = document.getElementsByClassName('pdf-wrapper')[0] as HTMLElement;
    if (!wrapper) return;

    const rect = wrapper.getBoundingClientRect();

    // 鼠标在 wrapper 内的坐标（屏幕坐标）
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;

    const oldScale = this.store.scale;
    // ⬆️ 滚轮方向
    let newScale = e.deltaY < 0
      ? oldScale + this.zoomStep
      : oldScale - this.zoomStep;

    newScale = Math.min(this.maxScale, Math.max(this.minScale, newScale));
    if (newScale === oldScale) return;

    // 🔑 以鼠标点为中心修正偏移
    this.left -= (mouseX / oldScale) * (newScale - oldScale);
    this.top -= (mouseY / oldScale) * (newScale - oldScale);

    this.store.scale = newScale;
  }


  markPoint(e) {
    this.markData = e ? e : null;
  }
  selectedArea(e) {
    if (e) {
      this.selectedAreaData = e;
      this.updateAreaText(e);
    } else {
      this.selectedAreaData = null;
      this.selectedAreaText = null;
    }
  }

  updateAreaText(data) {
    let selectedItem = null;
    if (this.pointData && this.pointData.length) {
      this.pointData.forEach((i) => {
        if (i.markMapList && i.markMapList.length) {
          const a = i.markMapList.find((m) => m.objectId == data.objectId);
          if (a) {
            selectedItem = i;
          }
        }
      })
    }

    if (selectedItem && selectedItem.subDrawingDTO) {
      this.changeMap = true;
      setTimeout(() => {
        this.markData = null;
      }, 500);
      
      this.isLoading = true;
      this.apiService.getGmpFloorPlanImg(selectedItem.subDrawingDTO.id).subscribe((res) => {
        this.isLoading = false;
        if (res) { 
          this.drawingDetail = res.DATA;
          this.selectedDrawingPlan = res.DATA;
          this.fileType = this.drawingDetail.fileDTO.type.replace('.', '');
          this.floorPlanUrl = this.drawingDetail.fileDTO.path;
          this.shapes = [];
          if (this.drawingDetail.gmpDrawingAreaDetails && this.drawingDetail.gmpDrawingAreaDetails.length) {
            this.drawingDetail.gmpDrawingAreaDetails.forEach((i) => {
              this.shapes = this.shapes.concat(i.markMapList);
            })
          }
          this.shapes = this.shapes ? cloneDeep(this.shapes) : [];
          this.pointData = res.DATA.gmpDrawingAreaDetails;
        }
      })
    } else {
      this.selectedAreaText = selectedItem ? selectedItem : null;
    }
  }

  resetZoom() {
    this.fabricCanvasCn.resetZoom();
  }

  async selectFloorPlan() {
    if (this.mode == 'view') {
      return;
    }
    history.pushState(null, null, document.URL);
    const modal = await this.modalCtrl.create({
      component: NewPageSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.common.map_point'),
        placeholderMessage: this.translateService.instant('shared_components.common.map_point'),
        originalOptionList: this.drawingManagementList,
        displayField: ['code', 'name'],
        valueField: '$self',
        multiSelect: false,
        format: '[$1] $2',
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.selectedDrawingPlan,
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(async res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('inspection.inspectionActivity.issueReporting');
      if (dd.env.platform !== 'notInDingTalk') {
        dd.biz.navigation.setTitle({
          title: this.translateService.instant('inspection.inspectionActivity.issueReporting') // 钉钉设置导航栏标题
        });
      }
      if (res.data) {
        this.selectedDrawingPlan = res.data;
        await this.getGmpFloorPlan();
        const data = this.gmpFloorPlan;
        this.drawingDetail = this.gmpFloorPlan;
        let shapes = [];
        data.gmpDrawingAreaDetails.forEach((i) => {
          shapes.push(i.markMapList[0])
        });
        this.selectedDrawingPlan.gmpDrawingAreaDetails = data.gmpDrawingAreaDetails;

        this.changeMap = true;
        this.floorPlanUrl = data.fileDTO.path;
        this.fileType = data.fileDTO.type.replace('.', '');
        this.pointData = this.selectedDrawingPlan.gmpDrawingAreaDetails ? this.selectedDrawingPlan.gmpDrawingAreaDetails : [];
        this.shapes = shapes;
      }
    });
    return await modal.present();
  }

  async getGmpFloorPlan(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.apiService.getGmpFloorPlanImg(that.selectedDrawingPlan.id).subscribe(res => {
        if (res && res.DATA) {
          that.gmpFloorPlan = res.DATA;
          resolve();
        } else {
          // that.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }


}
